import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        setTimeout(() => {
            requestAnimationFrame(() => {
                this.adjustBadgePosition()
            })
        }, 50)
    }

    adjustBadgePosition() {
        const badge = this.element.querySelector('.loyalty-progress-bar__level-badge')
        const fill = this.element.querySelector('.loyalty-progress-bar__fill')
        const track = this.element.querySelector('.loyalty-progress-bar__track')

        if (!badge || !fill || !track) return

        // Reset
        badge.style.transform = 'translateX(0)'

        void badge.offsetHeight

        const trackRect = track.getBoundingClientRect()
        const badgeRect = badge.getBoundingClientRect()

        let badgeShift = 0

        const rightOverflow = badgeRect.right - trackRect.right
        if (rightOverflow > 0) {
            badgeShift = -(rightOverflow - 8)
        }

        const leftOverflow = trackRect.left - badgeRect.left
        if (leftOverflow > 0) {
            badgeShift = leftOverflow -8
        }

        if (badgeShift !== 0) {
            badge.style.transform = `translateX(${badgeShift}px)`
        }
    }
}
